// Company info is stored as a single JSON object under the `site_settings` table
// using the key below. Public reads, admin writes (same RLS as other site settings).

export const COMPANY_INFO_SETTING_KEY = 'company_info';

export type LocationType = 'hq' | 'branch';

export interface CompanyLocation {
  id: string;
  type: LocationType;
  name: string;
  address: string;
  note: string;
}

export interface CompanyInfo {
  companyName: string;
  email: string;
  phoneKr: string;
  phoneCn: string;
  locations: CompanyLocation[];
}

export const DEFAULT_COMPANY_INFO: CompanyInfo = {
  companyName: 'GBCOSPACK',
  email: 'trade@gbcospack.com',
  phoneKr: '+82-2-1234-5678',
  phoneCn: '+86 21 0000 0000',
  locations: [
    {
      id: 'hq',
      type: 'hq',
      name: 'Seoul — Seongsu-dong',
      address: 'Seongsu-dong, Seongdong-gu, Seoul, South Korea',
      note: 'Global sourcing & customer success',
    },
    {
      id: 'b1',
      type: 'branch',
      name: 'Shanghai — Minhang',
      address: 'Minhang District, Shanghai, China',
      note: 'East China sourcing & QC',
    },
    {
      id: 'b2',
      type: 'branch',
      name: 'Guangzhou — Baiyun',
      address: 'Baiyun District, Guangzhou, China',
      note: 'South China sourcing & logistics',
    },
  ],
};

// Build a Google Maps embed URL from a free-text address.
export function buildMapEmbed(address: string): string {
  const query = encodeURIComponent(address);
  return `https://maps.google.com/maps?q=${query}&t=&z=14&ie=UTF8&iwloc=&output=embed`;
}

// Create a fresh empty location (used by the admin editor).
export function createEmptyLocation(type: LocationType): CompanyLocation {
  return {
    id:
      type === 'hq'
        ? 'hq'
        : `branch-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    type,
    name: '',
    address: '',
    note: '',
  };
}